import { format } from 'date-fns';
import { enUS, zhHK } from 'date-fns/locale';
import { i18n } from '@/shared/i18n';

const resolveLocale = () => (i18n.language.startsWith('zh') ? zhHK : enUS);

export const formatDateTime = (date: string | Date): string =>
  format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: resolveLocale() });

export const formatDate = (date: string | Date): string =>
  format(new Date(date), 'dd/MM/yyyy', { locale: resolveLocale() });

export const formatDateFull = (date: string | Date): string =>
  format(new Date(date), 'dd/MM/yyyy h:mm a', { locale: resolveLocale() });
